import React from 'react'
import { useSelector } from 'react-redux'

import { Layout } from '../../../components'
import { Initialize } from './Initialize'
import { Start } from './Start'
import { EmailVerificationForm } from './EmailVerificationForm'
import { PasswordForm } from './PasswordForm'
import { TeamNameFormLayout } from './TeamNameForm'
import { TeamUrlForm } from './TeamUrlForm'
import { Creating } from './Creating'
import { Finished } from './Finished'
import { UserStep } from './UserStep'
import { HookedJoinableTeams } from './JoinableTeams'

import { useProvideStepAnalytics } from '../../../hooks/useStepAnalytics'
import { usePathMetadata } from '../../../hooks/usePathMetadata'
import { Paths } from '../constants'
import { getStep } from './state'

import '../style.css'
import { CreateSteps } from './CreateSteps'

const STEP_TO_COMPONENT: {
  [key in CreateSteps]: React.ComponentType<{ superEnabled: boolean }>
} = {
  [CreateSteps.Initialize]: Initialize, //
  [CreateSteps.Start]: Start, //
  [CreateSteps.Password]: PasswordForm, //
  [CreateSteps.EmailVerification]: EmailVerificationForm, //
  [CreateSteps.CredentialsSubmitted]: UserStep,
  [CreateSteps.InformationsSubmitted]: TeamNameFormLayout,
  [CreateSteps.TeamUrlSubmitted]: TeamUrlForm,
  [CreateSteps.Creating]: Creating, //
  [CreateSteps.JoinableTeams]: HookedJoinableTeams, //
  [CreateSteps.Finished]: Finished, //
}

export function OrganizationCreate({
  superEnabled = false,
}: {
  superEnabled?: boolean
}) {
  const path = Paths.Create
  const Metadata = usePathMetadata(path)
  const step: CreateSteps = useSelector(getStep)
  const StepComponent = STEP_TO_COMPONENT[step]

  useProvideStepAnalytics(path)

  return (
    <>
      <Metadata />
      <Layout superEnabled={superEnabled}>
        <StepComponent superEnabled={superEnabled} />
      </Layout>
    </>
  )
}
